import fastApiImg from '../../assests/fast-api.png';
import postgresImg from '../../assests/postgresql.png';
import cicdImg from '../../assests/cicd.png';
import dockerImg from '../../assests/docker.png';
import langGraphImg from '../../assests/langGraph.png';
import pytorchImg from '../../assests/pytorch.png';
import tensorflowImg from '../../assests/tensorflow.png';
import scilearnImg from '../../assests/sci-learn.png';

interface TechItem {
  name: string;
  img: string;
}

const techItems: TechItem[] = [
  { name: 'FastAPI', img: fastApiImg },
  { name: 'PostgreSQL', img: postgresImg },
  { name: 'CI/CD', img: cicdImg },
  { name: 'Docker', img: dockerImg },
  { name: 'LangGraph', img: langGraphImg },
  { name: 'PyTorch', img: pytorchImg },
  { name: 'TensorFlow', img: tensorflowImg },
  { name: 'scikit-learn', img: scilearnImg },
];

// Duplicate for seamless loop
const allItems = [...techItems, ...techItems, ...techItems];

export default function TechBanner() {
  return (
    <div 
      className="relative w-full overflow-hidden py-16 md:py-20 mt-10"
      style={{ filter: 'drop-shadow(0 0 30px rgba(0, 185, 46, 0.4))' }}
    >
      {/* Background shape with bow-tie clip-path and glow */}
      <div 
        className="absolute inset-0 bg-[#00B92E]"
        style={{
          clipPath: 'polygon(0 0, 50% 30%, 100% 0, 100% 100%, 50% 70%, 0 100%)',
        }}
      />
      
      {/* Scrolling Content */}
      <div className="relative flex items-center h-[80px] animate-scroll-banner gap-16 whitespace-nowrap">
        {allItems.map((item, idx) => (
          <div
            key={`${item.name}-${idx}`}
            className="flex items-center gap-3 shrink-0"
          >
            <img
              src={item.img}
              alt={item.name}
              className="h-10 md:h-12 lg:h-14 w-auto object-contain"
              draggable={false}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
